import React from "react";
import { AppBar, Toolbar, Typography, useMediaQuery } from "@mui/material";
import { MenuDiv, MenuWrapper, StyledPersonOutline } from "./index.style";
import { useAuth } from "react-oidc-context";
import logo from "../../../../assets/images/logo.svg";
import icon from "../../../../assets/images/icon.svg";
import authorizedCall from "features/common/utils/authorizedCall";
import {
  /*PdfControllerService,*/ UserActionControllerService,
  CleanUpControllerService,
} from "openapi";
import { buildAuditRequestBody } from "features/user/utils/buildAuditRequestBody";

const AppHeader = (props: { authenticated: boolean }) => {
  const auth = useAuth();
  const { authenticated } = props;

  const isSmall = useMediaQuery("(max-width: 448px)");

  const handleLogout = () => {
    authorizedCall(UserActionControllerService.addUserAction, {
      requestBody: buildAuditRequestBody({
        cdOperation: "logout",
        description: "logout",
      }),
    })
      .then(() => {
        // TODO (only confirm that is correct)

        /*authorizedCall(PdfControllerService.cleanUpUserPdfs, {
          userId: auth.user?.profile.upn as string,
        }); */

        authorizedCall(CleanUpControllerService.cleanUpUserFiles, {});

        auth.signoutRedirect();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const menu = [
    {
      icon: <StyledPersonOutline sx={{ my: 1, mx: 1.5 }} />,
      id: "user",
      submenu: [
        {
          id: "logout",
          title: "Logout",
          click: handleLogout,
        },
      ],
    },
  ];

  const addMenuOpenedClass = (event: React.MouseEvent<HTMLElement>) => {
    event.currentTarget.querySelector(".submenu")?.classList.add("opened");
  };

  const removeMenuOpenedClass = (event: React.MouseEvent<HTMLElement>) => {
    event.currentTarget.querySelector(".submenu")?.classList.remove("opened");
  };

  const backToHome = () => {
    window.location.href = authenticated ? "/" : "/login";
  };

  return (
    <AppBar
      position="absolute"
      elevation={0}
      style={{ paddingRight: "24px", paddingLeft: "24px" }}
    >
      <Toolbar sx={{ flexWrap: "wrap" }}>
        <Typography
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1, cursor: "pointer" }}
          onClick={backToHome}
        >
          <span style={{ borderRight: "2px solid white", paddingRight: "5px" }}>
            <img src={logo} className="App-logo" alt="logo" />
          </span>
          <span style={{ paddingLeft: "5px" }}>
            <img src={icon} className="App-icon" alt="icon" />
          </span>
          <span style={{ paddingLeft: "5px" }}>
            Residential Mortgage Fund Reconciliation
          </span>
        </Typography>
        {authenticated && (
          <nav style={{ position: "relative" }}>
            {!isSmall && (
              <div>
                <span
                  style={{
                    position: "absolute",
                    right: "50px",
                    top: "12px",
                    fontSize: "12px",
                  }}
                >
                  {(auth.user?.profile.upn as string) ?? ""}
                </span>
              </div>
            )}

            {menu.map((item) => (
              <MenuWrapper
                test-id={"menu-item-" + item.id}
                onMouseEnter={addMenuOpenedClass}
                onMouseLeave={removeMenuOpenedClass}
                key={"menu-item-" + item.id}
              >
                {item.icon}
                {item.submenu ? (
                  <MenuDiv className={"submenu"}>
                    {item.submenu.map((subItem) => (
                      <div
                        onClick={subItem.click}
                        key={"submenu-item-" + subItem.id}
                      >
                        {subItem.title}
                      </div>
                    ))}
                  </MenuDiv>
                ) : (
                  <React.Fragment />
                )}
              </MenuWrapper>
            ))}
            {isSmall && (
              <div>
                <span
                  style={{
                    position: "absolute",
                    right: "50px",
                    top: "12px",
                    fontSize: "12px",
                  }}
                >
                  {(auth.user?.profile.upn as string) ?? ""}
                </span>
              </div>
            )}
          </nav>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
